import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopBar from './TopBar';
import SideNav from './SideNav';
import BottomNav from './BottomNav';
import './AppShell.css';

export default function AppShell() {
  const [sideNavOpen, setSideNavOpen] = useState(false);
  const location = useLocation();

  return (
    <div className="app-shell">
      <TopBar onMenuOpen={() => setSideNavOpen(true)} />
      <SideNav open={sideNavOpen} onClose={() => setSideNavOpen(false)} />
      <main className="app-shell__main" id="main-content">
        <div key={location.pathname} className="page-content anim-page-in">
          <Outlet />
        </div>
      </main>
      <BottomNav onMenuOpen={() => setSideNavOpen(true)} />
    </div>
  );
}
